/* Deal 22 – card "Buy now" buttons. Works WITH the COD form app: when the app puts its own Buy button in a card, our button simply triggers it; when the COD app is installed but has no button on the card, we open the product page (where the COD form lives); without the app we go straight to checkout. */
(function(){
  if(window.__d22cb4) return; window.__d22cb4=true;
  var RX=/buy\s*(it\s*)?now|order\s*now|cash on delivery|\bcod\b/i;
  function appActive(){return !!document.querySelector('script[src*="releasit" i],[id*="releasit" i],[class*="releasit" i],[data-releasit]')}
  function foreignBuy(root){
    if(!root) return null;
    var els=root.querySelectorAll('button,a[href],[role="button"],input[type="button"],input[type="submit"]');
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(el.closest('.d22-buyrow,.d22-sticky,.quick-add,.product-form__buttons,.wa-btn,.wa-fab,.card__heading')||el.matches('.d22-card-buy,.d22-buynow,.full-unstyled-link,.quick-add__submit')) continue;
      var t=(el.textContent||el.value||'').replace(/\s+/g,' ').trim();
      if(t&&t.length<40&&RX.test(t)) return el;
    }
    return null;
  }
  window.d22={appActive:appActive,foreignBuy:foreignBuy};
  function featured(w){return !!w.closest('[id*="__featured"]')}
  function good(w){
    var rows=w.querySelectorAll(':scope > .d22-buyrow').length, btns=w.querySelectorAll(':scope > .d22-card-buy').length;
    return featured(w) ? (rows===1&&btns===0) : (rows===0&&btns===1);
  }
  function findPrice(w){
    var p=w.querySelector('.card .price');
    if(p) return p;
    var all=[].slice.call(w.querySelectorAll('.price')).filter(function(x){return !x.closest('.d22-buyrow')});
    return all[0]||null;
  }
  function build(w){
    [].slice.call(w.querySelectorAll(':scope > .d22-buyrow, :scope > .d22-card-buy')).forEach(function(n){n.remove()});
    w.classList.remove('d22-has-row');
    var a=w.querySelector('a.full-unstyled-link[href*="/products/"]'); if(!a) return;
    var href=a.getAttribute('href'), m=href.match(/\/products\/([^\/?#]+)/); if(!m) return;
    var b=document.createElement('button');
    b.type='button'; b.className='d22-card-buy'; b.textContent='Buy now';
    b.setAttribute('data-handle',m[1]); b.setAttribute('data-url',href);
    if(featured(w)){
      var pr=findPrice(w);
      var row=document.createElement('div'); row.className='d22-buyrow';
      var ps=document.createElement('div'); ps.className='d22-buyrow__price';
      if(pr) ps.appendChild(pr.cloneNode(true));
      b.textContent='Buy Now';
      row.appendChild(ps); row.appendChild(b); w.appendChild(row);
      w.classList.add('d22-has-row');
    } else { w.appendChild(b); }
  }
  function decorate(root){
    (root||document).querySelectorAll('.product-card-wrapper').forEach(function(w){
      if(w.hasAttribute('data-d22cb')&&good(w)) return;
      w.setAttribute('data-d22cb','1');
      build(w);
    });
  }
  function equalize(){
    document.querySelectorAll('ul.product-grid, ul.grid').forEach(function(ul){
      var cards=[].slice.call(ul.querySelectorAll('.product-card-wrapper > .card'));
      if(!cards.length) return;
      cards.forEach(function(c){c.style.minHeight=''});
      var rows={};
      cards.forEach(function(c){var li=c.closest('li');if(!li) return;var top=Math.round(li.getBoundingClientRect().top+window.pageYOffset);(rows[top]=rows[top]||[]).push(c)});
      Object.keys(rows).forEach(function(k){
        var max=0;
        rows[k].forEach(function(c){max=Math.max(max,c.getBoundingClientRect().height)});
        rows[k].forEach(function(c){c.style.minHeight=max+'px'});
      });
    });
  }
  var eqT=0;
  function scheduleEq(){clearTimeout(eqT);eqT=setTimeout(equalize,150)}
  document.addEventListener('click',function(e){
    var b=e.target.closest('.d22-card-buy'); if(!b||b.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var url=b.getAttribute('data-url');
    var w=b.closest('.product-card-wrapper');
    /* 1) the COD app put its own button in this card: use it */
    var f=foreignBuy(w&&(w.parentElement||w));
    if(f){f.click();return}
    /* 2) the COD app is installed: its form lives on the product page */
    if(appActive()){window.location.href=url;return}
    /* 3) no app: add to cart and go straight to checkout */
    b.disabled=true;
    fetch('/products/'+b.getAttribute('data-handle')+'.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json()})
      .then(function(p){
        var v=p.variants||[], av=v.filter(function(x){return x.available});
        if(v.length===1&&av.length===1){
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:av[0].id,quantity:1})})
            .then(function(r){if(!r.ok) throw new Error('add');window.location.href='/checkout'});
        }
        window.location.href=url;
      })
      .catch(function(){window.location.href=url});
  },true);
  var t=0;
  function schedule(){if(t) return; t=requestAnimationFrame(function(){t=0;decorate();scheduleEq()})}
  decorate(); scheduleEq();
  window.addEventListener('load',function(){decorate();scheduleEq()});
  window.addEventListener('resize',scheduleEq);
  if('MutationObserver' in window) new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
})();
